import { Link } from 'react-router-dom';

export default function Footer() {
  const handleLinkClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-black text-white py-16">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <Link to="/" onClick={handleLinkClick} className="inline-block cursor-pointer">
              <img
                src="https://static.readdy.ai/image/43321df491d4a0e2e55deeaac186a2b1/bb193e26a7efa46a7d3714135b108385.jpeg"
                alt="朋睿"
                className="h-32 mb-6"
              />
            </Link>
            <p className="text-white/80 text-sm leading-relaxed mb-4">
              您的企業資金策略夥伴。我們致力於為創業家與中小企業主提供最專業的資金媒合與顧問服務，協助您在創業與擴張的道路上穩健前行。
            </p>
            <div className="flex items-center space-x-4">
              <a
                href="https://line.me/R/ti/p/@678gwbht"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors cursor-pointer"
              >
                <i className="ri-line-fill text-xl"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6">快速連結</h4>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/about"
                  onClick={handleLinkClick}
                  className="text-white/80 hover:text-white transition-colors text-sm cursor-pointer"
                >
                  關於朋睿
                </Link>
              </li>
              <li>
                <Link
                  to="/funders"
                  onClick={handleLinkClick}
                  className="text-white/80 hover:text-white transition-colors text-sm cursor-pointer"
                >
                  資金方服務
                </Link>
              </li>
              <li>
                <Link
                  to="/borrowers"
                  onClick={handleLinkClick}
                  className="text-white/80 hover:text-white transition-colors text-sm cursor-pointer"
                >
                  需求方服務
                </Link>
              </li>
              <li>
                <Link
                  to="/process"
                  onClick={handleLinkClick}
                  className="text-white/80 hover:text-white transition-colors text-sm cursor-pointer"
                >
                  媒合流程
                </Link>
              </li>
              <li>
                <Link
                  to="/cases"
                  onClick={handleLinkClick}
                  className="text-white/80 hover:text-white transition-colors text-sm cursor-pointer"
                >
                  成功案例
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6">服務項目</h4>
            <ul className="space-y-3 text-sm text-white/80">
              <li>銀行融資媒合</li>
              <li>創投資金媒合</li>
              <li>私募基金媒合</li>
              <li>策略投資媒合</li>
              <li>債券發行規劃</li>
              <li>財務顧問服務</li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6">聯絡資訊</h4>
            <ul className="space-y-4">
              <li className="flex items-start text-sm">
                <i className="ri-map-pin-line text-lg mr-3 flex-shrink-0 mt-0.5"></i>
                <span className="text-white/80">台北市內湖區行善路385號</span>
              </li>
              <li className="flex items-center text-sm">
                <i className="ri-phone-line text-lg mr-3 flex-shrink-0"></i>
                <a href="tel:02-27951331" className="text-white/80 hover:text-white cursor-pointer">
                  02-27951331
                </a>
              </li>
              <li className="flex items-center text-sm">
                <i className="ri-mail-line text-lg mr-3 flex-shrink-0"></i>
                <a href="mailto:contact@psfcapital.tw" className="text-white/80 hover:text-white cursor-pointer">
                  contact@psfcapital.tw
                </a>
              </li>
              <li className="flex items-center text-sm">
                <i className="ri-time-line text-lg mr-3 flex-shrink-0"></i>
                <span className="text-white/80">週一至週五 09:00-18:00</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/20 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-white/60 text-sm text-center md:text-left">
              © 2026 朋睿企業多元資金媒合平台. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <Link 
                to="/privacy-policy" 
                onClick={handleLinkClick}
                className="text-white/60 hover:text-white text-sm cursor-pointer"
              >
                隱私權政策
              </Link>
              <Link 
                to="/terms-of-service" 
                onClick={handleLinkClick}
                className="text-white/60 hover:text-white text-sm cursor-pointer"
              >
                服務條款
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}